<p-galleria
  #galleria
  [value]="slides"
  [showIndicators]="true"
  [showIndicatorsOnItem]="true"
  indicatorsPosition="bottom"
  [containerStyle]="{ width: '100%' }"
  maskClass="overflow-auto align-items-start z-dialog"
  [numVisible]="5"
  (activeIndexChange)="onSlide($event)"
  (visibleChange)="onClose()"
  [visible]="true"
  [circular]="true"
  [fullScreen]="true"
  [showThumbnailNavigators]="slides.length > 5"
  [showItemNavigators]="true">
  <ng-template pTemplate="item">
    <div class="galleria-overlay">
      <div class="galleria-content">
        <app-atlas-grid
          [bookmark]="content()"
          id="story"
          [forceReadOnly]="true"></app-atlas-grid>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="caption" let-item>
    <div class="absolute top-0 right-0 flex gap-2 mt-2 mr-8">
      <p-button
        styleClass="p-button-xs"
        [rounded]="true"
        label="Ansicht öffnen"
        icon="fas fa-arrow-up-right-from-square"
        (click)="openBookmark(item)"></p-button>
      <p-button
        styleClass="p-button-xs"
        [rounded]="true"
        label="Bericht teilen"
        icon="fa-solid fa-share-nodes"
        (click)="copyStoryLink(story._id)"></p-button>
    </div>
    <div class="flex flex-column gap-2">
      <app-header
        styleClass="m-0"
        [text]="item.title"
        icon="fas fa-note-sticky"></app-header>
      <div class="flex gap-2 align-items-center text-0">{{ story.title }}</div>
    </div>
  </ng-template>
  <ng-template pTemplate="thumbnail" let-item>
    <button
      class="p-button-sm"
      pButton
      [rounded]="true"
      [label]="item.title"></button>
  </ng-template>
</p-galleria>
